import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';

export const StarSVG = ({ starType, ratingStarFullFillColor }) => {
	const starColorEmpty = '#bcbec0';
	const starColorFull = ratingStarFullFillColor;
	let starFillLeft = starColorEmpty;
	let starFillRight = starColorEmpty;
	if (starType === 'full') {
		starFillLeft = starColorFull;
		starFillRight = starColorFull;
	} else if (starType === 'half') {
		starFillLeft = starColorFull;
	}
	return (
		<svg
			role="img"
			width="20"
			height="20"
			viewBox="0 0 32 32"
			aria-hidden="true"
		>
			<use x="0" fill={starFillLeft} href="#review-star-left" />
			<use x="14" fill={starFillRight} href="#review-star-right" />
		</svg>
	);
};

export const starLooper = (reviewRating, ratingStarFullFillColor) => {
	const starArray = [];
	for (let i = 1; i <= 5; i++) {
		let starType = 'empty';
		if (i <= reviewRating) {
			starType = 'full';
		} else if (i === Math.ceil(reviewRating)) {
			starType = 'half';
		}
		starArray.push(
			<StarSVG
				ratingStarFullFillColor={ratingStarFullFillColor}
				starType={starType}
				count={i}
				key={i}
			/>
		);
	}
	return starArray;
};

export const Rating = ({
	rating,
	source,
	labels,
	fontSize,
	ratingStarFullFillColor
}) => {
	const getMarkup = () => {
		if (source === 'FACEBOOK') {
			return (
				<div className={setClassNames(['rating', fontSize])}>
					{rating > 1
						? labels.get('RECOMMENDED')
						: labels.get('NOT_RECOMMENDED')}
				</div>
			);
		}
		return (
			<div
				className="rating"
				role="group"
				aria-label={labels
					.get('X_STAR_RATING')
					.replace('{rating}', rating)}
			>
				{starLooper(rating, ratingStarFullFillColor)}
			</div>
		);
	};
	return getMarkup();
};

Rating.propTypes = {
	rating: PropTypes.number.isRequired,
	source: PropTypes.string.isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func
	}).isRequired,
	fontSize: PropTypes.string,
	ratingStarFullFillColor: PropTypes.string
};

Rating.defaultProps = {
	fontSize: ''
};

StarSVG.propTypes = {
	starType: PropTypes.string.isRequired,
	ratingStarFullFillColor: PropTypes.string
};
